<template>
<div class="chapter">
<div class="inner_page">
<div class="book" title="Patina Farm"><div class="frontmatter"><div class="recto"><h1 class="title"><a id="index"></a>Patina Farm</h1><h3 class="author">Brooke
                        Giannetti and Steve Giannetti</h3><h4>Photographs by Lisa Romerein except as
                        indicated</h4><h4>Illustrations by Steve Giannetti</h4>
<p><span class="opt">Turn on Publisher Defaults for Optimal
                        Viewing</span></p><img alt="Gibbs Smith Logo" src="images/logo.jpg"/><div class="mediaobject" title="Photo of the Giannetti's home from the back."><img alt="Photo of the Giannetti's home from the back." src="images/Giannetti_PatinaFarmBook_ExteriorBack-0163_SW_V1.jpg"/></div></div><div class="verso"><p class="versotitle">Patina Farm</p><p>Digital Edition 1.0</p><p class="copyright">Text © 2016 Brooke Giannetti and Steve
                        Giannetti</p><p>Photographs © 2016 Lisa Romerein except as
                        indicated</p><p>All rights reserved. No part of this book may be reproduced
                        by any means whatsoever without written permission from the publisher,
                        except brief portions quoted for purpose of review.</p><p class="nobreak">Gibbs Smith</p><p class="nobreak">P.O. Box 667</p><p>Layton, Utah
                        84041</p><p class="nobreak">Orders:
                        1.800.835.4993</p><p>www.gibbs-smith.com</p><p>ISBN:
                    978-1-4236-4047-9</p></div></div><div class="frontmatter"><div class="dedication" title="Dedication"><p>To our children, Charlie, Nick and
                        Leila, for giving our dreams meaning.</p></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?1388ffb1